import React from 'react';


const Field = ({ input, label, type, meta: { touched, error } }) => (
  <div className="form-group">
    <label>{label}</label>
    <div>
      <input className="form-control" {...input} type={type} placeholder={label}/>
      <div className="form__errors">
        {touched && error && <span>{error}</span>}
      </div>
    </div>
  </div>
);


export default Field;



// WEBPACK FOOTER //
// ./src/components/Field/Field.js